import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';
import type {IEvent} from '../types/IEvent';
import {
  formatSequentialBookingData,
  type FormattedSequenceItem,
} from '../utils/sequential';


export const selectEventDetails = (state: IRootMachineSnapshot) => {
  return state.context.eventDetails;
};

export const selectPrimaryGuestName = (state: IRootMachineSnapshot) => {
  return (state.context.eventDetails as IEvent)?.primary_guest_name;
};

export const selectFormattedSequentialBookingData = (
  state: IRootMachineSnapshot,
): FormattedSequenceItem[] => {
  const eventTemplate = state.context.eventTemplate;
  const eventDetails = state.context.eventDetails;
  const events = Array.isArray(eventDetails) ? eventDetails : [];
  const language = state.context.language || 'en';

  if (!eventTemplate || !events.length) {
    return [];
  }

  return formatSequentialBookingData(eventTemplate, events, language);
};

export const selectIsSequentialEvent = (state: IRootMachineSnapshot) => {
  const eventDetails = state.context.eventDetails;
  if (Array.isArray(eventDetails)) {
    return eventDetails.length >= 1;
  }
  return !!(eventDetails as IEvent)?.group_id;
};
